import { render, staticRenderFns } from "./ShowPartnershipActivityMail.vue?vue&type=template&id=286b6560&"
import script from "./ShowPartnershipActivityMail.vue?vue&type=script&lang=js&"
export * from "./ShowPartnershipActivityMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports